module.exports = __webpack_public_path__ + "static/tryhard-japan-white-new-e8acbbb10d1924195168da16fd56e606.svg";